import React, { useEffect, useState } from "react";
import {
  Container, Row, Col, Card, Nav, Badge,
} from "react-bootstrap";
import { BsDot } from "react-icons/bs";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import avatar from '../../../assets/images/users/avatar-1.jpg'
import { userData } from "./model/profile.model";
import { IoSettingsOutline } from "react-icons/io5";
import { MdOutlineStorefront } from "react-icons/md";
const UserProfile: React.FC = () => {
  const [activeTab, setActiveTab] = useState("account");
  const [profileData, setProfileData] = useState<userData>();
  const authUser = localStorage.getItem("authPOSUser");
  const initial = profileData?.name ? profileData.name.charAt(0).toUpperCase() : "?";
  const selectUser = createSelector(
    (state: any) => state.Profile,
    (user) => user?.user
  );
  const user = useSelector(selectUser);
  useEffect(() => {
    if (authUser) {
      const obj = JSON.parse(authUser);
      setProfileData(obj);
    }
  }, [user]);
  return (
    <Container fluid className="py-4 mt-5 px-5 bg-light">
      <Row className="mt-5">
        {/* Sidebar */}
        <Col md={2} className="border-end bg-white shadow-sm">
          <div className="text-end pe-2 pt-2">
            <BsDot size={48} className="text-success" />
          </div>
          <div className="text-center py-3">
            <div
              className="rounded-circle  text-white d-flex justify-content-center align-items-center mx-auto"
              style={{
                width: "60px",
                height: "60px",
                fontSize: "24px",
                fontWeight: "bold",
                backgroundColor: '#B7002A'
              }}
            >
              {initial}
            </div>
            <h6 className="mt-3 mb-0 fw-bold">{profileData?.name}</h6>
            <small className="text-muted d-block">Role:</small>
            <Badge bg="secondary" className="mt-1">{profileData?.roleName}</Badge>
          </div>
        </Col>
        {/* Main Content */}
        <Col md={10} className="border-end bg-white shadow-sm">
          <Card className="p-4 shadow-sm">
            <Row className="align-items-center mb-3">
              <Col xs="auto">
                <div
                  className="rounded-circle text-white d-flex justify-content-center align-items-center mx-auto"
                  style={{
                    width: "60px",
                    height: "60px",
                    fontSize: "24px",
                    fontWeight: "bold",
                    backgroundColor: '#B7002A'
                  }}
                >
                  {initial}
                </div>
              </Col>
              <Col>
                <h5 className="mb-0 fw-semibold">{profileData?.name}</h5>
                <small className="text-muted">{profileData?.emailAddress}</small>
              </Col>
            </Row>
            {/* Tabs */}
            <Nav variant="tabs" className="mt-3" activeKey={activeTab}>
              <Nav.Item>
                <Nav.Link eventKey="account" onClick={() => setActiveTab("account")}>
                  Account
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="profile" onClick={() => setActiveTab("profile")}>
                  Store
                </Nav.Link>
              </Nav.Item>
            </Nav>
            {/* Account Tab Content */}
            {activeTab === "account" && (
              <div className="pt-4 px-3 border-bottom ">
                <h5 className="fw-bold mb-4">Personal Details</h5>
                <Row className="mb-3">
                  <Col md={6}>
                    <strong>Name:</strong> <span className="text-muted">{profileData?.name}</span>
                  </Col>
                  <Col md={6}>
                    <strong>Email:</strong> <span className="text-muted">{profileData?.emailAddress}</span>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={6}>
                    <strong>Mobile:</strong> <span className="text-muted">{profileData?.mobileNumber}</span>
                  </Col>
                  <Col md={6}>
                    <strong>Username:</strong> <span className="text-muted">{profileData?.userName}</span>
                  </Col>
                </Row>
              </div>
            )}
            {/* Store Tab Content */}
            {activeTab === "profile" && (
              <div className="pt-4 px-3 border-bottom">
                <Row className="mb-4">
                  <Col>
                    <h5 className="fw-bold mb-0">Store Information</h5>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <strong>Store Name:</strong>{" "}
                    <span className="text-muted">{profileData?.store?.storeName}</span>
                  </Col>
                  <Col>
                    <strong>GST No:</strong>{" "}
                    <span className="text-muted">{profileData?.store?.gstno}</span>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={6}>
                    <strong>Mobile Number:</strong>{" "}
                    <span className="text-muted">{profileData?.store?.mobileNumber}</span>
                  </Col>
                  <Col md={6}>
                    <strong>Address:</strong>{" "}
                    <span className="text-muted">{profileData?.store?.address}</span>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={6}>
                    <strong>Zipcode:</strong>{" "}
                    <span className="text-muted">{profileData?.store?.zipcode}</span>
                  </Col>
                  <Col md={6}>
                    <strong>Invoice Name:</strong>{" "}
                    <span className="text-muted">{profileData?.store?.invoiceName}</span>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={6}>
                    <strong>Site Link:</strong>{" "}
                    {profileData?.store?.siteLink ? (
                      <a
                        href={profileData.store.siteLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary text-decoration-underline"
                      >
                        {profileData.store.siteLink}
                      </a>
                    ) : (
                      <span className="text-muted">N/A</span>
                    )}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={6}>
                    <strong>Email:</strong>{" "}
                    <span className="text-muted">{profileData?.store?.email}</span>
                  </Col>
                </Row>
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
export default UserProfile;